import { Component, OnInit } from '@angular/core';
import { CinemaSelectorComponent } from 'libs/shared/src/lib/component/cinema-selector/cinema-selector.component';

@Component({ standalone: false, selector: 'app-cinema-selector', templateUrl: './cinema-selector.component.html' })
export class CustomCinemaSelectorComponent extends CinemaSelectorComponent implements OnInit {}
